import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ISetAmountPayload,
  ICurrentDistribution,
  ICurrentDistributionState,
  INewCreditPoolDistribution,
  ISetCreditPoolIdPayload,
  ISetCreditPoolNamePayload,
  ISetCreditPoolMembersPayload
} from './interfaces';
import { fetchCurrentDistribution, saveCreditPoolDistribution } from './currentDistribution.thunk';

export const initialState: ICurrentDistributionState = {
  loading: false,
  saving: false,
  isNewDistribution: false
};

const currentDistributionSlice = createSlice({
  name: 'currentDistribution',
  initialState,
  reducers: {
    cleanCurrentDistribution: (state) => {
      state.value = undefined;
      state.isNewDistribution = false;
    },
    enableNewDistributionMode: (state) => {
      state.isNewDistribution = true;
    },
    disableNewDistributionMode: (state) => {
      state.isNewDistribution = false;
    },
    appendCreditPool: (state, action: PayloadAction<INewCreditPoolDistribution>) => {
      if (!state.value?.creditPools) {
        return;
      }
      state.value.creditPools.push(action.payload);
    },
    setCreditPoolName: (state, action: PayloadAction<ISetCreditPoolNamePayload>) => {
      const { index, name } = action.payload;
      if (state.value?.creditPools?.[index]) {
        state.value.creditPools[index].name = name;
      }
    },
    setCreditPoolAmount: (state, action: PayloadAction<ISetAmountPayload>) => {
      const { index, amount } = action.payload;
      if (state.value?.creditPools?.[index]) {
        state.value.creditPools[index].amount = amount;
      }
    },
    setCreditPoolId: (state, action: PayloadAction<ISetCreditPoolIdPayload>) => {
      const { index, creditPoolId } = action.payload;
      if (state.value?.creditPools?.[index]) {
        state.value.creditPools[index]._id = creditPoolId;
      }
    },
    setCreditPoolMembers: (state, action: PayloadAction<ISetCreditPoolMembersPayload>) => {
      const { index, members } = action.payload;
      if (state.value?.creditPools?.[index]) {
        state.value.creditPools[index].members = members;
      }
    },
    removeCreditPool: (state, action: PayloadAction<number>) => {
      const index = action.payload;
      if (!state.value?.creditPools?.[index]) {
        return;
      }
      state.value.creditPools.splice(index, 1);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCurrentDistribution.pending, (state: ICurrentDistributionState) => {
      state.loading = true;
    });
    builder.addCase(fetchCurrentDistribution.fulfilled, (state: ICurrentDistributionState, action: PayloadAction<ICurrentDistribution>) => {
      state.loading = false;
      state.value = action.payload;
    });
    builder.addCase(fetchCurrentDistribution.rejected, (state: ICurrentDistributionState) => {
      state.loading = false;
    });
    builder.addCase(saveCreditPoolDistribution.pending, (state: ICurrentDistributionState) => {
      state.saving = true;
    });
    builder.addCase(saveCreditPoolDistribution.fulfilled, (state: ICurrentDistributionState) => {
      state.saving = false;
      state.value = undefined;
      state.isNewDistribution = false;
    });
    builder.addCase(saveCreditPoolDistribution.rejected, (state: ICurrentDistributionState) => {
      state.saving = false;
    });
  }
});

export const currentDistributionActions = currentDistributionSlice.actions;

export const currentDistributionReducer = currentDistributionSlice.reducer;

